'use strict';
/* COMPONENT - C04.10 Promotional homepage banner 1.0 */

import Listing from './uif_listing.js';

let homepageBanner = document.querySelectorAll('.promotional-homepage-banner'),
    i;

for (i = 0; i < homepageBanner.length; i += 1) {
    new Listing(homepageBanner[i]);
}
